export const getIconDetails = optionDetails => {
	const result = {
		isVisible: false,
		iconSource: ''
	};

	if (optionDetails?.contents?.['OPTION-PRODUCT-ICON']) {
		result.isVisible = true;
		result.iconSource = optionDetails.contents['OPTION-PRODUCT-ICON'];
	} else if (optionDetails?.productIcon) {
		result.isVisible = true;
		result.iconSource = optionDetails.productIcon;
	} else {
		result.isVisible = false;
		result.iconSource = null;
	}

	return result;
};
